<template>
    <CardPage :section="19" :page="3" next="/" nextLabel="Finish" :nextFunction="finish" :audio="true">
        <p>
            Awesome! You earned another sticker for completing this activity.
        </p>
        <ResponsiveImage :src="sticker.image" :alt="sticker.text"></ResponsiveImage>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        sticker: get('section19/sticker')
    },
    methods: {
        finish() {
            this.$store.set('section19/complete', true);
            this.$store.set('section19/sticker@earned', true);
        }
    }
};
</script>
